<template>
	<div>
		<div class="pcDiv hidden-sm-and-down">
			<el-row :gutter="10">
				<div class="dashboardDiv">
					<el-col :span="16">
						<div class="indexLeft">
							<div class="indexLeftToday comDiv maxWidth">
								<div>
									<p class="indexDivTitle">今日数据</p>
								</div>
								<div class="indexLeftTodayBjColor indexFlex">
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.vipNum?indexData.vipNum:0}}</p>
										<p class="toadyWord">新增会员(人)</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.czNum?indexData.czNum:0}}</p>
										<p class="toadyWord">充值订单(笔)</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.czMoney?indexData.czMoney:0}}</p>
										<p class="toadyWord">充值金额(元)</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.xfNum?indexData.xfNum:0}}</p>
										<p class="toadyWord">洗车卡消费(笔)</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.xfMoney?indexData.xfMoney:0}}</p>
										<p class="toadyWord">洗车卡消费(元)</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.xfCkMoney?indexData.xfCkMoney:0}}</p>
										<p class="toadyWord">洗车券消费(次)</p>
									</div>
									
								</div>
							</div>
							<div class="indexLeftChange comDiv maxWidth">
								<div>
									<p class="indexDivTitle">用户统计</p>
								</div>
								<div class="indexLeftChangeInfo indexFlex">
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.zVipNum?indexData.zVipNum:0}}</p>
										<p class="toadyWord">会员总数</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.zCzVipNum?indexData.zCzVipNum:0}}</p>
										<p class="toadyWord">已充值会员</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.wCzVipNum?indexData.wCzVipNum:0}}</p>
										<p class="toadyWord">未充值会员</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.czVipZb?indexData.czVipZb:0}}</p>
										<p class="toadyWord">充值会员占比</p>
									</div>
									<div class="todayInfo">
										<p class="todayNumber">{{indexData.fgVipNum?indexData.fgVipNum:0}}</p>
										<p class="toadyWord">复购会员数</p>
									</div>
								</div>
							</div>
							<div class="indexLeftMenu comDiv maxWidth">
								<div>
									<p class="indexDivTitle">快速入口</p>
								</div>
								<div class="indexLeftMenu indexFlex">
									<div class="todayInfo textCentet">
										<router-link to="/network/networklist">
											<img class="goToMenu" :src="mendian" alt="" />
											<p class="indexLeftMenuWord">门店列表</p>
										</router-link>
									</div>
									<div class="todayInfo textCentet" @click="goToDevice">
										<img class="goToMenu" :src="shebei" alt="" />
										<p class="indexLeftMenuWord">设备列表</p>
									</div>
									<div class="todayInfo textCentet" @click="goToBuyCard">
										<img class="goToMenu" :src="dingdan" alt="" />
										<p class="indexLeftMenuWord">订单查询</p>
									</div>
									<div class="todayInfo textCentet" @click="goToPackage">
										<img class="goToMenu" :src="chongzhi" alt="" />
										<p class="indexLeftMenuWord">洗车卡管理</p>
									</div>
									<div class="todayInfo textCentet" @click="goToVip">
										<img class="goToMenu" :src="huiyuan" alt="" />
										<p class="indexLeftMenuWord">会员管理</p>
									</div>
									<div class="todayInfo textCentet" @click="goToAdmin">
										<img class="goToMenu" :src="tianjia" alt="" />
										<p class="indexLeftMenuWord">核销管理</p>
									</div>
								</div>
							</div>
							
						</div>
					</el-col>
					<el-col :span="8">
						<div class="indexRight">
							<div class="indexRightNetWorkListDiv comDiv">
								<div class="indexRightNetWorkList indexFlex">
									<div class="indexFlex" style="align-items: center;">
										<div class="netWorkImg hidden-md-and-down">
											<img :src="defaultImg" alt="" />
										</div>
										<div>
											<p class="netWorkName">{{networkName}}</p>
											<p class="netWorkDefaultName">叮当蜂自助洗车</p>
										</div>
									</div>
									<div class="indexFlex" style="align-items: center;">
										<el-dropdown class="" @command="changeNetWork">
											<el-button class="changeNetWorkButton">
												<i class="el-icon-arrow-down ">切换</i>
											</el-button>
											<el-dropdown-menu lot="dropdown">
												<el-dropdown-item command="all">全部门店</el-dropdown-item>
												<el-dropdown-item v-for="item in options" :key='item.network_only' :command="item">{{item.network_name}}</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</div>
								<el-divider></el-divider>
								<div class="indexRightNetWorlDataDiv indexFlex">
									<div>
										<p class="dataNumber">{{indexData.zCzMoney?indexData.zCzMoney:0}}</p>
										<p class="dataWord">充值总金额</p>
									</div>
									<div>
										<p class="dataNumber">{{indexData.zIncomeMoney?indexData.zIncomeMoney:0}}</p>
										<p class="dataWord">实际总收入</p>
									</div>
								</div>
							</div>
							
						</div>
					</el-col>
				</div>
			</el-row>

		</div>

		<div class="mobileDiv hidden-md-and-up">
			
			<div class="mobileUseDiv">
				<div class="mobileIndexTitle">
					<div class="mobileIndexUserName mobileFlex itemCenter">
						<img class="mobileIndexUserImg" :src="mobile.mobileMoRen" alt="" />
						<p class="mobileIndexUserNameWord">{{username}}</p>
					</div>
					<div class="mobileChangNetWorkName">
						<el-dropdown class="mobileChangNetWorkName oneLine" trigger="click" @command="changeNetWork">
							<div class="el-dropdown-link mobileFlex">
								<p class="mobileChangNetWorkName oneLine">{{networkName}}</p><i class="el-icon-caret-bottom iconFont"></i>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="all">全部门店</el-dropdown-item>
								<el-dropdown-item v-for="item in options" :key="item.network_only"
									:command="item">{{item.network_name}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
				<div class="mobileCollapseDiv">
					<el-collapse v-model="activeNames">
						<el-collapse-item class="mobileCollapse mobileCollapseToday" name="1">
							<template slot="title">
								<div class="mobileFlex itemCenter mobileMenuDiv">
									<img class="mobileMenuIcon" :src="mobile.jinriIcon" alt="" />
									<p class="mobileMenuTitle">今日数据</p>
								</div>
							</template>
							<div class="mobileIndexDataDiv">
								<div class="mobileIndexData mobileFlex itemStart">
									<div class="mobileIndexDataInfo">
										<p class="mobileIndexDataNum">{{indexData.vipNum?indexData.vipNum:0}}</p>
										<p class="mobileIndexDataWord">新增会员(人)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.czNum?indexData.czNum:0}}</p>
										<p class="mobileIndexDataWord">充值订单(笔)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.czMoney?indexData.czMoney:0}}</p>
										<p class="mobileIndexDataWord">充值金额(元)</p>
									</div>
								</div>
								
								<div class="mobileIndexData mobileFlex itemStart">
									<div class="mobileIndexDataInfo">
										<p class="mobileIndexDataNum">{{indexData.xfNum?indexData.xfNum:0}}</p>
										<p class="mobileIndexDataWord">洗车卡消费(笔)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.xfMoney?indexData.xfMoney:0}}</p>
										<p class="mobileIndexDataWord">洗车卡消费(元)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.xfCkMoney?indexData.xfCkMoney:0}}</p>
										<p class="mobileIndexDataWord">洗车券消费(次)</p>
									</div>
								</div>
							</div>
						</el-collapse-item>
						
					</el-collapse>
				</div>
				
				<div class="mobileCollapseDiv">
					<el-collapse v-model="activeNames">
						<el-collapse-item class="mobileCollapse mobileCollapseUserCount" name="2">
							<template slot="title">
								<div class="mobileFlex itemCenter mobileMenuDiv">
									<img class="mobileMenuIcon" :src="mobile.yonghuIcon" alt="" />
									<p class="mobileMenuTitle">用户统计</p>
								</div>
							</template>
							<div class="mobileIndexDataDiv">
								<div class="mobileIndexData mobileFlex itemStart">
									<div class="mobileIndexDataInfo">
										<p class="mobileIndexDataNum">{{indexData.zVipNum?indexData.zVipNum:0}}</p>
										<p class="mobileIndexDataWord">会员总数(人)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.zCzVipNum?indexData.zCzVipNum:0}}</p>
										<p class="mobileIndexDataWord">已充值会员(人)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.wCzVipNum?indexData.wCzVipNum:0}}</p>
										<p class="mobileIndexDataWord">未充值会员(人)</p>
									</div>
								</div>
								
								<div class="mobileIndexData mobileFlex itemStart">
									<div class="mobileIndexDataInfo">
										<p class="mobileIndexDataNum">{{indexData.czVipZb?indexData.czVipZb:0}}</p>
										<p class="mobileIndexDataWord">充值占比(%)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.fgVipNum?indexData.fgVipNum:0}}</p>
										<p class="mobileIndexDataWord">复购会员数(人)</p>
									</div>
								</div>
							</div>
						</el-collapse-item>
						
					</el-collapse>
				</div>
				
				<div class="mobileCollapseDiv">
					<el-collapse v-model="activeNames">
						<el-collapse-item class="mobileCollapse mobileJingYingMoney" name="3">
							<template slot="title">
								<div class="mobileFlex itemCenter mobileMenuDiv">
									<img class="mobileMenuIcon" :src="mobile.jingyingIcon" alt="" />
									<p class="mobileMenuTitle">经营金额</p>
								</div>
							</template>
							<div class="mobileIndexDataDiv">
								<div class="mobileIndexData mobileFlex itemStart">
									<div class="mobileIndexDataInfo">
										<p class="mobileIndexDataNum">{{indexData.zCzMoney?indexData.zCzMoney:0}}</p>
										<p class="mobileIndexDataWord">充值总金额(元)</p>
									</div>
									<div class="mobileIndexDataInfo mobileIndexDataMarginLeft">
										<p class="mobileIndexDataNum">{{indexData.zIncomeMoney?indexData.zIncomeMoney:0}}</p>
										<p class="mobileIndexDataWord">实际总收入(元)</p>
									</div>
								</div>
							</div>
						</el-collapse-item>
						
					</el-collapse>
				</div>
				
				<div class="mobileIndexCard">
					<div class="mobileWorkTitle">常用功能</div>
					<div class="mobileFlex spaceBetween">
						<div v-show="ddShow" class="mobileIndexMenu" @click="goToBuyCard">
							<img :src="mobile.menu1" alt="" />
						</div>
						
						<div v-show="hyShow" class="mobileIndexMenu" @click="goToVip">
							<img :src="mobile.menu2" alt="" />
						</div>

						<div v-show="mdShow" class="mobileIndexMenu" @click="goToNetWorkListShow">
							<img :src="mobile.menu5" alt="" />
						</div>
						
						<div v-show="sbShow" class="mobileIndexMenu" @click="goToDevice">
							<img :src="mobile.menu6" alt="" />
						</div>
					</div>
				</div>
				
				<div class="mobileIndexCard">
					<div class="mobileWorkTitle">其他功能</div>
					<div class="mobileFlex justifyStart wrap mobileOtherDiv">
						
						<div v-if="['1', '3'].includes(userViewBill)" v-show="chongzhiShow" class="mobileIndexMenuOther" @click="goToCwData">
							<img :src="mobile.caiwuSuiIcon" alt="" />
						</div>
						<div v-if="['2', '3'].includes(userViewBill)" v-show="chongzhiShow" class="mobileIndexMenuOther" @click="goToYbData">
							<img :src="mobile.caiwuYiIcon" alt="" />
						</div>
						
						<div v-show="xckShow" class="mobileIndexMenuOther" @click="goToPackage">
							<img :src="mobile.menu7" alt="" />
						</div>
						
						<div v-show="yhqShow" class="mobileIndexMenuOther" @click="goToCounp">
							<img :src="mobile.menu8" alt="" />
						</div>

						<div v-show="shujvShow" class="mobileIndexMenuOther" @click="goToSj">
							<img :src="mobile.sjIcon" alt="" />
						</div>
					<!-- </div>
					<div class="mobileFlex spaceBetween"> -->
						<div v-show="dhShow" class="mobileIndexMenuOther" @click="goToExchange">
							<img :src="mobile.menu10" alt="" />
						</div>
						
						<div v-show="duanxianShow" class="mobileIndexMenuOther" @click="goToMes">
							<img :src="mobile.menu11" alt="" />
						</div>
						
						<div v-show="zengsongShow" class="mobileIndexMenuOther" @click="goToGive">
							<img :src="mobile.menu12" alt="" />
						</div>

						<!-- <div v-show="zengsongShow" class="mobileIndexMenuOther" @click="goToGive">
							<img :src="mobile.vipIcon" alt="" />
						</div>

						<div v-show="zengsongShow" class="mobileIndexMenuOther" @click="goToGive">
							<img :src="mobile.yingxiaoIcon" alt="" />
						</div> -->
						
						<div class="mobileIndexMenuOther" @click="adminAction('logout')">
							<img :src="mobile.menu13" alt="" />
						</div>
					</div>
				</div>
				
				<div class="mobileIndexCard">
					<div class="mobileWorkTitle">设备状态</div>
					<div class="mobileDevStatus mobileFlex spaceBetween">
						<div class="mobileDevStatusDiv" @click="goToRun">
							<p class="mobileDevStatusNum yel">{{deviceRun}}</p>
							<p class="mobileDevStatusWord">运行中</p>
						</div>
						<div class="mobileDevStatusDiv" @click="goToNoRun">
							<p class="mobileDevStatusNum gre">{{deviceKx}}</p>
							<p class="mobileDevStatusWord">空闲中</p>
						</div>
						<div class="mobileDevStatusDiv" @click="goToLiXian">
							<p class="mobileDevStatusNum hui">{{deviceLx}}</p>
							<p class="mobileDevStatusWord">离线中</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import MyEcharts from '@/components/MyEcharts.vue'
	import Decimal from 'decimal.js'
	import {
		NetWorkList,
		indexData,
		allNotice,
		getDev
	} from "@/request/api"
	export default {
		data() {
			return {
				activeNames:['1','2','3'],
				username: this.$getLoginInfo().userName,
				accountShow: false,
				userRoleMenuAll:localStorage.getItem("userRoleMenuAll"),
				userViewBill:localStorage.getItem("userViewBill"),
				mdShow:false,
				xckShow:false,
				yhqShow:false,
				passwordShow:false,
				showS1:false,
				dhShow:false,
				sbShow:false,
				hyShow:false,
				duanxianShow:false,
				shujvShow:false,
				zengsongShow:false,
				ddShow:false,
				chongzhiShow:false,
				deviceKx:'',
				deviceRun:'',
				deviceLx:'',
				
				mendian: require("@/assets/image/mendianguanli1.png"),
				shebei: require("@/assets/image/shebeiguanli.png"),
				dingdan: require("@/assets/image/dingdanchaxun.png"),
				chongzhi: require("@/assets/image/chongzhitaocan.png"),
				huiyuan: require("@/assets/image/huiyuanguanli.png"),
				tianjia: require("@/assets/image/hx.png"),
				netWorkImg: require("@/assets/image/changenetwork.png"),
				defaultImg: require("@/assets/image/userdefault.png"),
				todayUser: '',
				todayPay: '',
				todayPayNum: '',
				todayUse: '',
				todayUseNum: '',
				todayOrder: '',
				todayDevice: '',
				tradeAll: '',
				incomeAll: '',
				indexNetWork: "all",
				smsNotice: true,
				options: '',
				networkName: "切换网点",
				networkOnly: "all",
				networkAddress: "",
				zhuanhuaVip:'',
				indexData:[],
				mobile: {
					mobileMoRen: require("@/assets/mobile/image/index/moren.png"),
					jinriIcon: require("@/assets/mobile/image/index/jinriIcon.png"),
					yonghuIcon: require("@/assets/mobile/image/index/yonghuIcon.png"),
					jingyingIcon: require("@/assets/mobile/image/index/jingyingIcon.png"),
					menu1:require("@/assets/mobile/image/index/dingdanIcon.png"),
					menu2:require("@/assets/mobile/image/index/huiyuanIcon.png"),
					menu3:require("@/assets/mobile/image/index/caiwuIcon.png"),
					menu4:require("@/assets/mobile/image/index/shujvIcon.png"),
					menu5:require("@/assets/mobile/image/index/mendianIcon.png"),
					menu6:require("@/assets/mobile/image/index/shebeiIcon.png"),
					menu7:require("@/assets/mobile/image/index/xichekaIcon.png"),
					menu8:require("@/assets/mobile/image/index/xichequanIcon.png"),
					menu9:require("@/assets/mobile/image/index/yingxiaoIcon.png"),
					menu10:require("@/assets/mobile/image/index/duihuanIcon.png"),
					menu11:require("@/assets/mobile/image/index/duanxinIcon.png"),
					menu12:require("@/assets/mobile/image/index/zengsongIcon.png"),
					menu13:require("@/assets/mobile/image/index/tuichuIcon.png"),
					caiwuSuiIcon:require("@/assets/mobile/image/index/caiwuSuiIcon.png"),
					caiwuYiIcon:require("@/assets/mobile/image/index/caiwuYiIcon.png"),
					sjIcon:require("@/assets/mobile/image/index/sjIcon.png"),
					vipIcon:require("@/assets/mobile/image/index/vipIcon.png"),
					yingxiaoIcon:require("@/assets/mobile/image/index/yingxiaoIcon.png")
				}
			}

		},
		
		created() {
			this.userMenu()
			this.getNetWork()
			this.getNotice()
			this.indexDataAll()
			this.getDevList()
		},

		activated() {
			
			
		},
		deactivated() {
			
			
		},

		methods: {
			
			
			userMenu() {
				
				const userRoleMenuAll = JSON.parse(this.$data.userRoleMenuAll)
				userRoleMenuAll.forEach((column, index) => {
					console.log(column)
					if(column.label == "门店管理"){
						this.$data.wdShow = true
						if(column.children){
							column.children.forEach((second,secondkey)=>{
								
								if(second.label == "门店列表"){
									this.$data.mdShow = true
								}
								
								if(second.label == "设备列表"){
									this.$data.sbShow = true
								}
								
								if(second.label == "会员列表"){
									this.$data.hyShow = true
								}
								
								if(second.label == "订单管理"){
									this.$data.ddShow = true
								}
								
								if(second.label == "核销管理"){
									this.$data.hxShow = true
								}
								
								if(second.label == "洗车卡管理"){
									this.$data.xckShow = true
								}
								
								if(second.label == "洗车券管理"){
									this.$data.yhqShow = true
								}
								
								if(second.label == "兑换管理"){
									this.$data.dhShow = true
								}
								
								if(second.label == "短信管理"){
									this.$data.duanxianShow = true
								}
							})
						}
					}
					
					if(column.label == "数据分析"){
						this.$data.sjShow = true
						if(column.children){
							column.children.forEach((second,secondkey)=>{
								console.log(second.label)
								if(second.label == "门店数据概览"){
									this.$data.shujvShow = true
									
								}
								
							})
						}
					}
					
					if(column.label == "财务管理"){
						this.$data.cwShow = true
						if(column.children){
							column.children.forEach((second,secondkey)=>{
								if(second.label == "充值明细"){
									this.$data.chongzhiShow = true
								}
								
							})
						}
					}
					
					if(column.label == "其他管理"){
						this.$data.qtShow = true
						if(column.children){
							column.children.forEach((second,secondkey)=>{
								
								if(second.label == "修改密码"){
									this.$data.passwordShow = true
								}
								
								if(second.label == "赠额管理"){
									this.$data.zengsongShow = true
								}
							})
						}
					}
				})
			},

			
			getNetWork() {
				var formData = new FormData()
				formData.append("limit", "99999")
				formData.append("page", "1")
				NetWorkList(formData).then(res => {
					if (res.code == 20000) {
						this.$data.options = res.data.data
					}
				})
			},

			getNotice() {
				allNotice().then(res => {
					if (res.code == 20000) {
						if (res.data.simCard) {
							this.$confirm(res.data.simCard.count, res.data.simCard.title, {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$router.push({
									path: '/network/devicelist'
								})
							}).catch(() => {

							});
							return false
						}

						if (res.data.sms) {
							this.$confirm(res.data.sms.count, res.data.sms.title, {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$router.push({
									path: '/network/messagelist'
								})
							}).catch(() => {

							});
							return false
						}

					}
				})

			},

			getSmsNotice(title, message) {
				this.$notify({
					title: title,
					message: message,
					type: 'warning',
					duration: 0
				})
			},

			changeEchartsByPay() {
				this.$data.mobile.btnChecked = true
			},
			changeEchartsByUse() {
				this.$data.mobile.btnChecked = false
			},
			openMenu() {
				this.$data.mobile.dialog = true
			},
			handleClose() {
				this.$data.mobile.dialog = false
			},
			cancelForm() {
				this.$data.mobile.loading = false;
				this.$data.mobile.dialog = false;
			},
			goToNetWorkListShow() {
				this.$router.push({
					path: '/network/networklist'
				})
			},
			goToDevice() {
				this.$router.push({
					path: '/network/devicelist'
				})
			},
			goToBuyCard() {
				this.$router.push('/buycard')
			},
			goToPackage() {
				this.$router.push('/network/card')
			},
			goToVip() {
				this.$router.push('/network/vip')
			},
			goToAdmin() {
				this.$router.push('/network/hxlist')
			},
			goToUserset() {
				this.$router.push('/userset')
			},
			goToNetworkData() {
				this.$router.push('/dataForm/networkData')
			},
			goToUserData() {
				this.$router.push('/dataForm/userData')
			},
			goToVipData() {
				this.$router.push('/dataForm/vipData')
			},
			goToYxData() {
				this.$router.push('/dataForm/marketData')
			},
			goToKdData() {
				this.$router.push('/dataForm/crossStoreData')
			},
			goToCwData() {
				this.$router.push('/order/orderList')
			},

			goToYbData() {
				this.$router.push('/yibao/yibaopaylist')
			},

			goToHx() {
				this.$router.push('network/hxlist')
			},
			goToCounp() {
				this.$router.push('/network/coupon')
			},
			goToExchange() {
				this.$router.push('/network/exchange')
			},
			goToMes() {
				this.$router.push('/network/messagelist')
			},
			goToSj() {
				this.$router.push('/dataForm/networkData')
			},
			
			goToGive(){
				this.$router.push('/giveindex')
			},
			
			goToYx(){
				this.$router.push('/activenetworkList')
			},
			
			goToRun(val){
				this.$router.push({
					path: '/rundevice',
					query: {
						networkId: this.$data.networkOnly,
						type:1
					}
				})
			},
			
			goToNoRun(val){
				this.$router.push({
					path: '/norundevice',
					query: {
						networkId: this.$data.networkOnly,
						type:2
					}
				})
			},
			
			goToLiXian(val){
				this.$router.push({
					path: '/noonlinedevice',
					query: {
						networkId: this.$data.networkOnly,
						type:3
					}
				})
			},

			adminAction(command) {
				if (command == "logout") {
					this.$confirm("即将退出登录，是否继续", '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 清除localStorage
						localStorage.clear();
						// 清除sessionStorage
						sessionStorage.clear();
						this.$message({
							type: 'success',
							message: '退出成功!即将返回登录页'
						});
						setTimeout(() => {
							this.$router.push('/login')
						}, 1500)
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消退出'
						});
					})
				}
				
				if(command == "changePassword"){
					this.goToUserset()
				}
				
				if(command == "gotos1"){
					this.$confirm('请选择您的身份', '提示', {
					  confirmButtonText: '代理商',
					  cancelButtonText: '合作伙伴',
					  type: 'warning'
					}).then(() => {
					  window.location.href = 'https://s1.ddfkj.com/manage/login/index'
					}).catch(() => {
					  window.location.href = 'https://s1.ddfkj.com/hezuo/login/index'         
					});
					
				}
			},
			
			indexDataAll(){
				var formData = new FormData()
				formData.append("wdName",this.$data.networkOnly)
				indexData(formData).then(res=>{
					
					if(res.code == "20000"){
						this.$data.indexData = res.data
					}else{
						this.$message({
							type: 'warning',
							message: res.message
						})
						this.$data.indexData = []
						
					}
				})
			},
			
			changeNetWork(command) {
				if(command == "all"){
					this.$data.networkOnly = "all"
					this.$data.networkName = "全部网点"
				}else{
					this.$data.networkName = command.network_name
					this.$data.networkOnly = command.network_only
				}
				
				this.getNotice()
				this.indexDataAll()
				this.getDevList()
				
			},
			
			getDevList(){
				var formData = new FormData()
				formData.append("wd",this.$data.networkOnly)
				getDev(formData).then(res=>{
					if(res.code == "20000"){
						this.$data.deviceKx = res.data.kx
						this.$data.deviceLx = res.data.lx
						this.$data.deviceRun = res.data.run
					}else{
						this.$message({
							type: 'warning',
							message: res.message
						})
					}
				})
			}

		},
		components: {
			MyEcharts
		}
	}
</script>

<style lang="less" scoped>
	.el-dropdown-menu{
		max-height: 500px;
		overflow-y: auto;
	}
	
	.dashboardDiv {
		margin: 32px;
		font-size: 16px;

		.goToMenu {
			max-width: 54px;
			width: 100%
		}

		.indexFlex {
			display: flex;
		}

		.maxWidth {
			max-width: 1093px;
		}

		.comDiv {
			padding: 0.26rem;
			margin-bottom: 0.21rem;
			background-color: #ffffff;
			border-radius: 10px;
		}

		.indexDivTitle {
			font-size: 0.21rem;
			margin-bottom: 0.26rem;
			font-family: hm_bold;

			@media screen and (min-width:992px) and (max-width:1200px) {
				font-size: 18px;
			}
		}

		.todayInfo {
			text-align: left;
			padding: 32px 0;
		}

		.textCentet {
			text-align: center;
		}

		.indexLeftTodayBjColor {
			flex-direction: row;
			justify-content: space-around;
			align-items: center;
			background: linear-gradient(to top right, rgba(255, 253, 247, 0.9), rgba(255, 253, 245, 0.22), rgba(255, 252, 247, 1));
		}
		
		.todayNumber {
			font-size: 0.32rem;
			font-family: hm_bold;
			color: rgba(32, 32, 32, 1);
		
			@media screen and (min-width:992px) and (max-width:1200px) {
				font-size: 22px;
			}
		}
		
		.toadyWord {
			font-size: 0.19rem;
			font-family: hm_regular;
			color: rgba(32, 32, 32, 0.6);
			margin-top: 5px;
		
			@media screen and (min-width:992px) and (max-width:1200px) {
				font-size: 14px;
			}
		}

		.indexLeftChangeInfo {
			flex-direction: row;
			justify-content: space-between;

			.todayInfo {
				padding: 0;
			}


			.todayInfo img {
				/* width: 0.54rem;
				height: 0.54rem; */
			}

			.indexLeftChangeInfoTitle {
				font-size: 0.19rem;
				font-family: hm_regular;
				color: rgba(32, 32, 32, 0.6);

				@media screen and (min-width:992px) and (max-width:1200px) {
					font-size: 16px;
				}
			}

			.indexLeftChangeInfoNumber {
				font-size: 0.42rem;
				font-family: hm_medium;
				color: rgba(32, 32, 32, 1);
				margin-top: 16px;
				margin-bottom: 10px;

				@media screen and (min-width:992px) and (max-width:1200px) {
					font-size: 23px;
				}
			}

			.indexLeftChangeInfoRatioImg {
				margin-left: 10px;
				margin-right: 5px;
			}

			.indexLeftChangeInfoRatio {
				color: rgba(32, 32, 32, 0.4);
				font-family: hm_regular;
				align-items: center;
			}

			.indexLeftChangeInfoRatioWord {
				font-size: 0.16rem;

				@media screen and (min-width:992px) and (max-width:1200px) {
					font-size: 13px;
				}
			}
		}

		.indexLeftMenu {
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			.todayInfo {
				padding: 0;
			}
		}

		.indexLeftEcharts {

			.indexEcharts {
				flex-direction: row;
				justify-content: space-between;
			}

			.indexEchartsTitle {
				font-size: 0.19rem;
				color: rgba(32, 32, 32, 1);
				font-family: hm_regular;

				@media screen and (min-width:992px) and (max-width:1200px) {
					font-size: 16px;
				}
			}

			th>.cell {
				font-size: 0.16rem;
				color: rgba(32, 32, 32, 1);
				font-family: hm_regular;
				text-align: left;

				@media screen and (min-width:992px) and (max-width:1200px) {
					font-size: 14px;
				}
			}

			td>.cell {
				font-size: 0.16rem;
				color: rgba(32, 32, 32, 0.6);
				font-family: hm_regular;
				text-align: left;

				@media screen and (min-width:992px) and (max-width:1200px) {
					font-size: 14px;
				}
			}


			::v-deep .el-table--border th.el-table__cell,
			::v-deep .el-table td.el-table__cell {
				border-bottom: none !important;
			}

			::v-deep .el-table--border .el-table__cell {
				border-right: none !important;
			}

			::v-deep .el-table--group,
			.el-table--border {
				border: none !important;
			}

			.el-table::before {
				height: 0;
			}
		}

		.indexLeftMenuWord {
			color: rgba(32, 32, 32, 0.6);
			margin-top: 10px;
			font-size: 0.19rem;
			font-family: hm_regular;

		}

		.indexRight {
			margin-left: 17px;
			max-width: 510px;
			width: 100%;

			.indexRightNetWorkList {
				flex-direction: row;
				justify-content: space-between;

				.netWorkImg {
					width: 100%;
					max-width: 64px;
					margin-right: 10px;
				}

				.netWorkName {
					font-size: 0.21rem;
					color: rgba(56, 56, 56, 1);
					font-family: hm_bold;
					margin-top: 4px;
					margin-bottom: 6px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;

					}
				}

				.netWorkDefaultName {
					font-size: 0.16rem;
					color: rgba(252, 151, 0, 1);
					font-family: hm_regular;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 12px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}

				.changeNetWorkByPc {
					min-width: 120px;
					width: 100%;
					font-size: 16px;
					color: rgba(32, 32, 32, 1);
					font-family: hm_regular;

				}

				.changeNetWorkButton {
					border: 0;
				}

				.btnInStyle {
					align-items: center;
				}
			}

			.indexRightNetWorlDataDiv {
				justify-content: space-around;
				text-align: center;

				.dataNumber {
					font-family: hm_medium;
					color: #000000;
					font-size: 0.26rem;
				}

				.dataWord {
					font-size: 16px;
					font-family: hm_regular;
					color: rgba(0, 0, 0, 0.4);
					margin-top: 15px;
				}
			}

			.userInfoBtn {
				width: 100%;
				margin-top: 16px;
				border: 0;
				background-color: rgba(255, 182, 0, 1);
				color: rgba(255, 255, 255, 0.9);
				border-radius: 6px;
				padding: 13px 0;
				font-size: 18px;
			}

			.indexRightDeviceStatusDiv {
				max-height: 413px;
				min-height: 4.13rem;
				overflow: auto;

				.indexRightDeviceStatus {
					align-items: center;
					padding-left: 17px;
					font-size: 0.18rem;
					font-family: hm_regular;
					color: #202020;
					margin-bottom: 20px;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;
					}
				}

				.lixian {
					background-color: rgba(255, 87, 51, 0.31);
					color: #FF5733;
					padding: 5px 10px;
					font-size: 0.16rem;
					font-family: hm_regular;
					border-radius: 5px;
					margin-right: 10px;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;
					}
				}

				.kongxian {
					background-color: rgba(67, 207, 124, 0.1);
					color: rgba(67, 207, 124, 1);
					padding: 5px 10px;
					font-size: 16px;
					font-family: hm_regular;
					border-radius: 5px;
					margin-right: 10px;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;
					}
				}

				.yunxing {
					background-color: rgba(255, 182, 0, 0.1);
					color: #FFB600;
					padding: 5px 10px;
					font-size: 16px;
					font-family: hm_regular;
					border-radius: 5px;
					margin-right: 10px;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;
					}
				}

				.mRight {
					margin-right: 15px;
				}
			}

			.indexRightpackageDiv {
				.indexEchartsTitle {
					font-size: 0.19rem;
					color: rgba(32, 32, 32, 1);
					font-family: hm_regular;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;
					}
				}

				th>.cell {
					font-size: 0.16rem;
					color: rgba(32, 32, 32, 1);
					font-family: hm_regular;

					text-align: left;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;
					}
				}

				td>.cell {
					font-size: 0.16rem;
					color: rgba(32, 32, 32, 0.6);
					font-family: hm_regular;

					text-align: left;

					@media screen and (min-width:992px) and (max-width:1200px) {
						font-size: 14px;
					}
				}


				::v-deep .el-table--border th.el-table__cell,
				::v-deep .el-table td.el-table__cell {
					border-bottom: none !important;
				}

				::v-deep .el-table--border .el-table__cell {
					border-right: none !important;
				}

				::v-deep .el-table--group,
				.el-table--border {
					border: none !important;
				}

				.el-table::before {
					height: 0;
				}
			}

		}
	}
	
	.mobileDiv{
		background-color: #F6F6F6;
	}
	
	.mobileIndexTitle{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding-top: 1.5625rem;
		padding-bottom: 2.25rem;
	}
	
	.mobileIndexUserImg{
		width:4.625rem;
		height:4.62rem;
	}
	
	.mobileIndexUserNameWord{
		margin-left: 1.375rem;
		font-size: 2.25rem;
		color: #000000;
	}
	
	.mobileChangNetWorkName{
		font-size: 1.75rem;
		color: #000000;
	}
	
	.mobileCollapse{
		border-radius: 0.75rem;
		border: 0;
	}

	.mobileMenuDiv{
		padding-left: 1.375rem;
	}
	
	.mobileMenuIcon{
		width:2.25rem;
		height:2.25rem;
	}
	
	.mobileMenuTitle{
		font-size: 1.9375rem;
		color: #383838;
		margin-left: 1rem;
	}
	
	::v-deep .el-collapse{
		border:0;
		border-radius: 0.75rem;
	}
	
	::v-deep .el-collapse-item__wrap{
		border:0;
		border-radius: 0 0 0.75rem 0.75rem;
	}
	
	::v-deep .mobileCollapse .el-collapse-item__header{
		height: 5.25rem;
		line-height: 5.25rem;
		border:0;
		color:#383838;
	}
	
	::v-deep .mobileCollapseToday .el-collapse-item__header{
		background: linear-gradient(to right,#FFF2CC 0,#FFF7DE 26%,#ffffff 100%);
	}
	
	::v-deep .mobileCollapseUserCount .el-collapse-item__header{
		background: linear-gradient(to right,#E7F0FF 0,#F0F5FF 26%,#ffffff 100%);
	}
	
	::v-deep .mobileJingYingMoney .el-collapse-item__header{
		background: linear-gradient(to right,#E6FAFF 0,#E6FAFF 26%,#ffffff 100%);
	}
	
	::v-deep .el-collapse-item__content{
		padding: 0;
	}
	
	.mobileCollapseDiv{
		margin-bottom:1.5rem;
	}
	
	.mobileIndexDataDiv{
		padding-bottom: 1.75rem;
	}
	
	.mobileIndexData{
		width:40.125rem;
		margin: 0 auto;
		margin-top: 1.25rem;
		padding-top: 0.5rem;
	}
	
	.mobileIndexDataInfo{
		width:11rem;
		height:8.625rem;
		text-align: left;
		padding-left:1rem;
	}
	
	.mobileIndexDataNum{
		font-size: 2.125rem;
		color:#000000;
	}
	
	.mobileIndexDataWord{
		font-size: 1.5rem;
		color:#707070;
	}
	
	.mobileIndexDataMarginLeft{
		margin-left: 2.0625rem;
	}
	
	.mobileWorkTitle{
		font-size: 1.9375rem;
		color:#383838;
		margin-bottom: 1.5rem;
	}
	
	.mobileIndexCard{
		background-color: #ffffff;
		border-radius: 0.75rem;
		padding-top:2rem;
		padding-left: 2rem;
		padding-right: 2rem;
		padding-bottom: 1.75rem;
		margin-bottom: 1.5rem;
	}
	
	.mobileIndexMenu{
		width: 7.75rem;
		height: 9rem;
	}
	
	.mobileIndexMenu > img{
		width: 100%;
	}
	
	.mobileIndexMenuOther{
		flex: 0 0 calc(20% - 0.75rem);
		min-width: 7.75rem;
		min-height:7.9375rem;
	}
	
	.mobileIndexMenuOther > img{
		width:100%;
	}
	
	.mobileDevStatusDiv{
		width: 11.875rem;
		height: 10.5625rem;
		background-color: #FAFAFA;
		border-radius: 1.125rem;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.mobileDevStatusNum{
		font-size: 3rem;
	}
	
	.mobileDevStatusWord{
		font-size: 1.5rem;
		color:#000000;
		margin-top: 0.2rem;
	}
	
	.yel{
		color:#FFB600;
	}
	
	.gre{
		color:#00BAAD;
	}
	
	.hui{
		color:#808080;
	}

	.mobileOtherDiv{
		gap: 2.6rem;
	}
</style>
